import { Button } from "react-bootstrap";

function BtnInverse() {
  return (
    <>
        <div className="card-body">
            <h4 className="card-title">Inverse buttons</h4>
            <p className="card-description">Add class <code>.btn-inverse-&#123;color&#125; for inverse buttons</code></p>
            <div className="template-demo">
                <Button variant="inverse-primary btn-fw">Primary</Button>
                <Button variant="inverse-secondary btn-fw">Secondary</Button>
                <Button variant="inverse-success btn-fw">Success</Button>
                <Button variant="inverse-danger btn-fw">Danger</Button>
                <Button variant="inverse-warning btn-fw">Warning</Button>
                <Button variant="inverse-info btn-fw">Info</Button>
                <Button variant="inverse-light btn-fw">Light</Button>
                <Button variant="inverse-dark btn-fw">Dark</Button>
                <Button variant="link btn-fw">Link</Button>
            </div>
        </div>
    </>
  )
}

export default BtnInverse